// Client-side visibility rules. The backend is the actual gate — these only
// keep restricted pages out of the nav for people who can't use them.
// Keep in sync with DEVELOPER_QUALITY_EMAILS in script/modules/api_auth.py.
export const DEVELOPER_QUALITY_EMAILS = [
  'maruthi.janardhan@exotel.com',
  'sumithra@exotel.com',
];

export function canViewDeveloperQuality(user) {
  const email = (user?.email || '').trim().toLowerCase();
  return DEVELOPER_QUALITY_EMAILS.includes(email);
}

// Keep in sync with ADMIN_EMAILS in script/modules/api_auth.py (defaults to the
// same list). Gates the API Keys / risk-worker settings page in the nav.
export function canManageApiKeys(user) {
  return canViewDeveloperQuality(user);
}
